import React from 'react'
import MobileEmptyStateCard from '../../components/MobileEmptyStateCard'
import { formatMoney, formatDiscountPercent } from '../../helpers/utils'

const SalesOrderLineCard = ({ item }) => {
  const staticRows = [
    ['Código', item.product_db_ref],
    ['Unidad', item.package_unit],
    ['Cantidad', Number(item.quantity || 0).toFixed(2)],
    ['Precio', formatMoney(Number(item.price || 0))],
    ['% descuento', formatDiscountPercent(item.discount)],
    ['Sub-total', formatMoney(Number(item.gross_price || 0))]
  ]

  return (
    <div className="order-detail-line-card">
      <div className="order-detail-line-product-name">{item.product_name}</div>
      {staticRows.map(([label, value]) => (
        <div key={label} className="order-detail-line-row">
          <span className="order-detail-line-label">{label}</span>
          <span className="order-detail-line-value">{value}</span>
        </div>
      ))}
    </div>
  )
}

const SalesOrderDetailsTabMobileLines = ({ items }) => {
  if (!items?.length) {
    return (
      <MobileEmptyStateCard
        title="No hay productos"
        description="Cuando este pedido ERP tenga productos asociados, aparecerán aquí."
      />
    )
  }

  return (
    <div className="order-detail-line-items-mobile">
      {items.map((item, index) => (
        <SalesOrderLineCard key={index} item={item} />
      ))}
    </div>
  )
}

export default SalesOrderDetailsTabMobileLines
